import React from 'react';
import './GalleryHeader.css';

const GalleryHeader = ({ galleryName }) => {
  return (
    <div style={{
      position: 'fixed',
      top: '20px', 
      left: '20px',
      zIndex: 9999,
      background: 'none',
      backdropFilter: 'none',
      padding: '8px 16px',
      borderRadius: '0',
      whiteSpace: 'nowrap'
    }}>
      <svg 
        width="20" 
        height="20" 
        viewBox="0 0 226.72 340.08"
        xmlns="http://www.w3.org/2000/svg"
        style={{ display: 'inline-block', verticalAlign: 'middle', marginRight: '12px' }}
      >
        <path 
          fill="white" 
          d="M174.19,0h-32.49c-2.79,0-5.06,2.26-5.06,5.06v30.82c0,2.79-2.26,5.06-5.06,5.06h-37.84c-2.79,0-5.06-2.26-5.06-5.06V5.06c0-2.79-2.26-5.06-5.06-5.06h-32.49c-2.79,0-5.06,2.26-5.06,5.06v30.82c0,2.79-2.26,5.06-5.06,5.06H5.06c-2.79,0-5.06,2.26-5.06,5.06v28.37c0,2.79,2.26,5.06,5.06,5.06h35.99c2.79,0,5.06,2.26,5.06,5.06v171.06c0,2.79-2.26,5.06-5.06,5.06H5.06c-2.79,0-5.06,2.26-5.06,5.06v28.37c0,2.79,2.26,5.06,5.06,5.06h35.99c2.79,0,5.06,2.26,5.06,5.06v30.91c0,2.79,2.26,5.06,5.06,5.06h32.49c2.79,0,5.06-2.26,5.06-5.06v-30.91c0-2.79,2.26-5.06,5.06-5.06h37.84c2.79,0,5.06,2.26,5.06,5.06v30.91c0,2.79,2.26,5.06,5.06,5.06h32.49c2.79,0,5.06-2.26,5.06-5.06v-30.91c0-2.79,2.26-5.06,5.06-5.06h37.36c2.79,0,5.06-2.26,5.06-5.06v-28.37c0-2.79-2.26-5.06-5.06-5.06h-37.36c-2.79,0-5.06-2.26-5.06-5.06V84.46c0-2.79,2.26-5.06,5.06-5.06h37.36c2.79,0,5.06-2.26,5.06-5.06v-28.37c0-2.79-2.26-5.06-5.06-5.06h-37.36c-2.79,0-5.06-2.26-5.06-5.06V5.06c0-2.79-2.26-5.06-5.06-5.06ZM131.59,260.58h-37.84c-2.79,0-5.06-2.26-5.06-5.06V84.46c0-2.79,2.26-5.06,5.06-5.06h37.84c2.79,0,5.06,2.26,5.06,5.06v171.06c0,2.79-2.26,5.06-5.06,5.06Z"
        />
      </svg>
      <span style={{ color: 'rgba(255,255,255,0.6)', fontSize: '16px', marginRight: '12px', verticalAlign: 'middle', textShadow: '0 1px 3px rgba(0, 0, 0, 0.8)' }}>|</span>
      <span style={{ color: 'white', fontSize: '14px', fontWeight: '600', verticalAlign: 'middle', textShadow: '0 1px 3px rgba(0, 0, 0, 0.8)' }}>
        {galleryName}
      </span>
      {/* <span style={{ color: 'rgba(255,255,255,0.7)', fontSize: '10px', textTransform: 'uppercase', letterSpacing: '0.8px', marginLeft: '8px', verticalAlign: 'middle' }}>
        • OPEN DETAILS
      </span> */}
    </div>
  );
};

export default GalleryHeader;